<template>
  <div class="input__button" @click="send" style="background-color: #06ba77">
    Send It!
  </div>
</template>

<script>
export default {
  name: "InputButton",
  methods: {
    send(event) {
      console.log("Sending in MY version!");
      this.$emit("newOwnMessage");
    },
  },
};
</script>

<style>
</style>
